import { useRef } from 'react';
import { ReactSVG } from 'react-svg';
import Text from '../Text';
import Button from '../../../../components/Button';
import dynamicfunction from '../../../../utils/dynamicfunction';
import icons from '../../../../constants/icons';
import { fontSizes } from '../../../../constants/constants';
import { cn } from '../../../../utils/utils';

export default function UploadCard({ title, description, upload, name, onClick, onDeleteDocument, isRequired = false }) {
  const { TextWeight } = dynamicfunction();
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      onClick?.(e.target.files[0]);
    }
  };

  return (
    <div className='border-2 border-dashed border-camel-tan rounded-lg p-4 sm:p-7 flex flex-col justify-between relative'>
      {name && <ReactSVG src={icons.delete_big_red} onClick={onDeleteDocument} className='cursor-pointer absolute top-3 right-3' />}
      <div className={`flex items-center gap-4 sm:gap-6`}>
        <div>
          <ReactSVG src={icons.link} />
        </div>
        <div>
          <Text
            text={<>
              <Text
                text={title}
                size={fontSizes.h14}
                isTruncate={false}
                color={'text-primary'}
                weight={TextWeight.medium}
              />
              <Text
                text={" *"}
                color={'text-red'}
              />
            </>}
            size={fontSizes.h14}
            isTruncate={false}
            weight={TextWeight.medium}
            className={cn('pb-1 block line-clamp-3', (name ?? description) ? 'pr-5 break-all' : '')}
          />
          <Text text={name ?? description} size={fontSizes.h11} isTruncate={false} color={'text-primary'} weight={TextWeight.regular} />
        </div>
      </div>
      <input ref={fileInputRef} type='file' className='hidden' onChange={handleFileChange} />

      <Button
        text={upload}
        color={'text-primary hover:text-white'}
        bgColor='bg-white hover:bg-primary'
        className={'border border-primary mt-4 text-center'}
        onClick={handleButtonClick}
      />
    </div>
  );
}
